"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var CheckIcon_1 = require("../Icons/CheckIcon");
var propTypes = {
    label: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.element.isRequired
    ]),
    variant: PropTypes.oneOf(['asFormRow']),
    colorScheme: PropTypes.oneOf(['regular', 'inverted']),
    error: PropTypes.bool
};
var CheckboxWithinContext = /** @class */ (function (_super) {
    __extends(CheckboxWithinContext, _super);
    function CheckboxWithinContext(props) {
        var _this = _super.call(this, props) || this;
        _this.inputId = props.id || props.ergoElements.idGenerator.next();
        return _this;
    }
    CheckboxWithinContext.prototype.render = function () {
        var _a = this.props, children = _a.children, label = _a.label, error = _a.error, className = _a.className, variant = _a.variant, colorScheme = _a.colorScheme, ergoElements = _a.ergoElements, other = __rest(_a, ["children", "label", "error", "className", "variant", "colorScheme", "ergoElements"]);
        var componentClassName = classNames(className, "ee_checkbox--" + colorScheme, {
            ee_checkbox: true,
            'ee_checkbox--row': variant === 'asFormRow',
            'ee_is-invalid': error
        });
        var labelClassName = classNames('ee_checkbox__label', "ee_checkbox__label--" + colorScheme, "ee_checkbox__label--" + variant);
        var checkboxInput = (React.createElement(React.Fragment, null,
            React.createElement("input", __assign({}, other, { id: this.inputId, "data-focus-id": this.inputId, type: "checkbox", className: classNames('ee_checkbox__control', "ee_checkbox__control--" + colorScheme), "aria-invalid": error })),
            React.createElement("span", { className: classNames('ee_checkbox__box', "ee_checkbox__box--" + colorScheme) },
                React.createElement(CheckIcon_1.default, { className: classNames('ee_checkbox__icon', "ee_checkbox__icon--" + colorScheme), width: 16, height: 16 }))));
        if (variant === 'asFormRow') {
            return (React.createElement("div", { className: componentClassName },
                React.createElement("label", { htmlFor: this.inputId }, checkboxInput),
                React.createElement("div", { className: labelClassName },
                    React.createElement("label", { htmlFor: this.inputId }, label))));
        }
        else {
            return (React.createElement("label", { htmlFor: this.inputId, className: componentClassName },
                checkboxInput,
                React.createElement("span", { className: labelClassName }, label)));
        }
    };
    CheckboxWithinContext.propTypes = propTypes;
    CheckboxWithinContext.defaultProps = {
        error: false,
        variant: undefined,
        colorScheme: 'regular',
        label: undefined,
        ergoElements: undefined
    };
    return CheckboxWithinContext;
}(react_1.Component));
exports.CheckboxWithinContext = CheckboxWithinContext;
//# sourceMappingURL=CheckboxWithinContext.js.map
